import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const getSinglePartnerFunc = createAsyncThunk(
  "getSinglePartner",
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`dashboard/partners/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const getSinglePartnerSlicer = createSlice({
  name: "getSinglePartner",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSinglePartnerFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSinglePartnerFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data?.partner || action.payload?.partner || null;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getSinglePartnerFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSinglePartnerSlicer.reducer;
